import React from 'react';
import { ArrowRight, MessageSquare } from 'lucide-react';

const Hero: React.FC = () => {
  const phone = "584141967028";
  const message = "Hola Stellionet, estoy en [País] y necesito asesoría técnica para mi empresa. Actualmente tenemos un requerimiento sobre [Explicación breve del problema] y me gustaría agendar una breve llamada con un especialista.";
  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <section
      id="home"
      className="min-h-[80vh] relative flex items-center pt-32 pb-48 lg:pb-40 lg:pt-20 overflow-hidden bg-[#f5f5f5]"
      aria-label="Introducción Stellionet"
    >
      <div className="max-w-7xl mx-auto px-4 my-[5rem] sm:px-6 lg:px-8 w-full relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* INFORMACIÓN: */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary/10 border border-primary/20 text-primary text-[10px] sm:text-xs font-bold uppercase tracking-widest mb-6">
              <span className="w-2 h-2 rounded-full bg-secondary"></span>
              Soluciones Tecnológicas Integrales
            </div>

            {/* Título */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-extrabold text-[#003d4a] mb-6 tracking-tight leading-[1.1]">
              Impulsamos su <br className="hidden sm:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-[#00c597]">
                Continuidad Operativa
              </span>
            </h1>
            {/* Subtítulo */}
            <p className="max-w-xl mx-auto lg:mx-0 text-base sm:text-lg text-dark-1000 mb-8 sm:mb-10 leading-relaxed">
              Stellionet integra soluciones de alta ingeniería para que su empresa mantenga el enfoque en los objetivos estratégicos, garantizando un rendimiento técnico excepcional.
            </p>

            {/* Botones: Stack vertical en móvil*/}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#services"
                className="btn-primary-hero flex items-center justify-center gap-2 group w-full sm:w-auto"
                aria-label="Ver nuestros servicios de ingeniería"
              >
                Ver Soluciones
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
              </a>

              {/* Botón: Consultoría Especializada */}
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="relative w-full sm:w-auto p-[2px] rounded-full overflow-hidden group transition-all duration-300 hover:shadow-[0_0_15px_rgba(0,197,151,0.3)]"
                title="Abrir WhatsApp para consultoría"
              >
                {/* FONDO 1: El degradado inicial (Primary to Secondary) */}
                <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary transition-opacity duration-500 group-hover:opacity-0" />

                {/* FONDO 2: El color Secondary sólido que aparece en hover */}
                <div className="absolute inset-0 bg-secondary opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                {/* CONTENIDO BLANCO INTERNO */}
                <div className="relative w-full h-full px-5 py-4 gap-2 bg-white rounded-full flex items-center justify-center text-primary font-black transition-colors duration-300">
                  <MessageSquare
                    className="w-5 h-5 transition-colors duration-300 group-hover:text-secondary"
                    aria-hidden="true"
                  />
                  <span className="transition-colors duration-300 group-hover:text-secondary">
                    Consultoría Especializada
                  </span>
                </div>
              </a>
            </div>
          </div>

          {/* IMAGEN PRINCIPAL: */}
          <div className="relative order-1 lg:order-2 px-4 sm:px-12 lg:px-0">
            <div className="relative z-10 max-w-[500px] mx-auto lg:max-w-none">

              {/* Marco Decorativo */}
              <div className="absolute -inset-2 sm:-inset-4 border border-secondary rounded-3xl -z-10 block" aria-hidden="true"></div>

              <div className="rounded-2xl overflow-hidden shadow-[0_10px_30px_rgba(0,61,74,0.1)] lg:shadow-[0_20px_50px_rgba(0,61,74,0.15)] border-[4px] sm:border-[8px] border-white">
                <picture>
                  <source media="(max-width: 767px)" srcSet="/assets/hero_movil.webp" />
                  <source media="(min-width: 768px)" srcSet="/assets/hero.webp" />
                  <img
                    src="/assets/hero.webp"
                    alt="Ingeniería Inteligente Stellionet"
                    // ESTO ES LO QUE FALTA:
                    width="1000"
                    height="667"
                    fetchPriority="high" // Indica al navegador que descargue esto antes que el JS
                    loading="eager"      // NUNCA uses lazy en el Hero
                    decoding="sync"      // Fuerza a que se procese de inmediato
                    className="w-full h-auto aspect-[3/2] object-cover rounded-2xl"
                  />
                </picture>
              </div>

              {/* Card Flotante Informativa */}
              <div className="absolute -bottom-4 -left-2 sm:-bottom-6 sm:-left-6 bg-white p-3 sm:p-4 rounded-xl shadow-xl border border-primary/5 flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-secondary/20 rounded-lg flex items-center justify-center shrink-0">
                  <span className="text-primary font-bold text-sm ">100%</span>
                </div>
                <div>
                  <p className="text-[10px] text-slate-500 font-bold uppercase leading-none mb-1">Uptime</p>
                  <p className="text-xs sm:text-sm font-bold text-primary uppercase">Garantizado</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;